import { useDroppable } from '@dnd-kit/core';
import type { Data } from '@dnd-kit/core/dist/store';
import { classNames } from '@framework/utils';

type Props = {
  id: string;
  disabled?: boolean;
  data?: Data;
  children: React.ReactNode;
  className?: string;
  hoveredClassName?: string;
};

export const Droppable: React.FC<Props> = ({ id, disabled, data, children, className, hoveredClassName }: Props) => {
  const { active, setNodeRef, isOver } = useDroppable({ id, disabled, data });

  return (
    <div ref={setNodeRef} className={classNames(className, active && isOver ? hoveredClassName : undefined)}>
      {children}
    </div>
  );
};
